export const typography = {
  htmlFontSize: 16,
  fontFamily: '"Roboto Mono", monospace',
  fontSize: 14,
  fontWeightLight: 400,
  fontWeightRegular: 500,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: '"Roboto Slab", serif',
  },
  h2: {
    fontFamily: '"Roboto Slab", serif',
  },
  h3: {
    fontFamily: '"Roboto Slab", serif',
  },
  h4: {
    fontFamily: '"Roboto Slab", serif',
  },
  h5: {
    fontFamily: '"Roboto Slab", serif',
  },
  h6: {
    fontFamily: '"Roboto Slab", serif',
  },
  subtitle1: {
    fontFamily: '"Roboto Mono", monospace',
  },
  subtitle2: {
    fontFamily: '"Roboto Mono", monospace',
  },
  body1: {
    fontFamily: '"Roboto Mono", monospace',
  },
  body2: {
    fontFamily: '"Roboto Mono", monospace',
  },
  button: {
    fontFamily: '"Roboto Mono", monospace',
  },
  caption: {
    fontFamily: '"Roboto Mono", monospace',
  },
  overline: {
    fontFamily: '"Roboto Mono", monospace',
  },
};
